/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Group_EmptyInputs */

const en_fw_bm_group_empty = /** @type {(inputs: Fw_Bm_Group_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No group in this cut reaches 5 tasks yet.`)
};

const id_fw_bm_group_empty = /** @type {(inputs: Fw_Bm_Group_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada kelompok pada potongan ini yang mencapai 5 task.`)
};

/**
* | output |
* | --- |
* | "No group in this cut reaches 5 tasks yet." |
*
* @param {Fw_Bm_Group_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_group_empty = /** @type {((inputs?: Fw_Bm_Group_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Group_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_group_empty(inputs)
	return en_fw_bm_group_empty(inputs)
});